import { IPropertyConverter, JsonValueObject } from "ta-json";

import { MapStringTo } from "../base-types";
import { RelationResource } from "../models/relation-resource";
import { RelationResourceConverter } from "./relation-resource-converter";

export class AggregatedEntityRelationsConverter implements IPropertyConverter {
    /**
     * Serializes a string map to {@link PageComponentResource} map.
     *
     * @param value - The map of strings to {@link RelationResource}s
     * @returns A JSON value object.
     */
    serialize(value: MapStringTo<RelationResource>): JsonValueObject {
        const result: JsonValueObject = {};

        const relationResourceConverter = new RelationResourceConverter();

        Object.keys(value).forEach(relationName => {
            const relationResource = value[relationName];

            result[relationName] = relationResourceConverter.serialize(relationResource);
        });

        return result;
    }

    /**
     * Deserializes a JSON object into a string to {@link RelationResource} map.
     *
     * @param value - A JSON object
     * @returns A mapping of strings to {@link RelationResource}s.
     */
    deserialize(value: JsonValueObject): MapStringTo<RelationResource> {
        if (!value) {
            return {};
        }

        const result: MapStringTo<RelationResource> = {};

        const relationResourceConverter = new RelationResourceConverter();

        Object.keys(value).forEach(relationName => {
            const relationResourceData = value[relationName];

            result[relationName] = relationResourceConverter.deserialize(relationResourceData) as RelationResource;
        });

        return result;
    }
}
